import { render, staticRenderFns } from "./BadReceiptPurchase.vue?vue&type=template&id=14955219&"
import script from "./BadReceiptPurchase.vue?vue&type=script&lang=js&"
export * from "./BadReceiptPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports